/* CP Warenkorb: Seitenleiste, AJAX-In-den-Warenkorb, Zähler im Header. */
(function(){
  if (window.CPCart) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawer = document.getElementById('cp-cart-drawer');
  var isCartPage = /\/cart\/?$/.test(location.pathname);
  var lastFocus = null, busy = false;

  function money(cents){
    try { return new Intl.NumberFormat('de-DE', { style:'currency', currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
    catch(e){ return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function img(url, w){
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function json(url, opts){
    return fetch(url, Object.assign({ credentials:'same-origin', headers:{ 'Accept':'application/json' } }, opts || {}))
      .then(function(r){ return r.json().then(function(d){ if (!r.ok) { var e = new Error(d.description || d.message || 'Fehler'); e.data = d; throw e; } return d; }); });
  }

  /* ---------- Zähler im Header ---------- */
  function setCount(n){
    var els = document.querySelectorAll('.cpsh__cart b, .cpsh__mcart b, [data-cp-cart-count]');
    Array.prototype.forEach.call(els, function(el){ el.textContent = n; el.style.display = n > 0 ? '' : 'none'; });
    var c = drawer && drawer.querySelector('[data-cpcd-count]');
    if (c) c.textContent = n > 0 ? '(' + n + ')' : '';
  }

  /* ---------- Rendern ---------- */
  function render(cart){
    setCount(cart.item_count);
    if (!drawer) return;
    var body = drawer.querySelector('[data-cpcd-body]'), foot = drawer.querySelector('[data-cpcd-foot]');
    if (!cart.items.length){
      body.innerHTML = '<div class="cpcd__empty"><b>Dein Warenkorb ist leer</b>Stöbere in unseren Kategorien – wir beraten dich gern.<br><br>' +
        '<a class="cpcd__btn" href="' + root + '" data-cpcd-close>Weiter einkaufen</a></div>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function(it, i){
      var line = i + 1, meta = [];
      if (it.variant_title && it.variant_title !== 'Default Title') meta.push(esc(it.variant_title));
      if (it.properties) Object.keys(it.properties).forEach(function(k){
        var v = it.properties[k]; if (!v || k.charAt(0) === '_') return; meta.push(esc(k) + ': ' + esc(v));
      });
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<div class="cpcd__item">' +
        '<a class="cpcd__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a class="cpcd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (meta.length ? '<p class="cpcd__meta">' + meta.join(' · ') + '</p>' : '') +
        '<div class="cpcd__row"><div class="cpcd__qty">' +
          '<button type="button" data-cpcd-qty="' + line + '" data-q="' + (it.quantity - 1) + '" aria-label="Menge verringern">−</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-cpcd-qty="' + line + '" data-q="' + (it.quantity + 1) + '" aria-label="Menge erhöhen">+</button>' +
        '</div><span class="cpcd__price">' + was + money(it.final_line_price) + '</span></div>' +
        '<button type="button" class="cpcd__rm" data-cpcd-qty="' + line + '" data-q="0">Entfernen</button></div></div>';
    }).join('');
    drawer.querySelector('[data-cpcd-total]').textContent = money(cart.total_price);
    foot.hidden = false;
  }
  function msg(text, err){
    if (!drawer) return;
    var m = drawer.querySelector('[data-cpcd-msg]');
    if (!text){ m.hidden = true; return; }
    m.className = 'cpcd__msg' + (err ? ' cpcd__msg--err' : '');
    m.innerHTML = (err ? '' : '<svg viewBox="0 0 24 24"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>') + esc(text);
    m.hidden = false;
  }
  function refresh(){ return json(root + 'cart.js').then(function(c){ render(c); return c; }); }

  /* ---------- Öffnen / Schließen ---------- */
  function open(){
    if (!drawer || isCartPage) { location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function(){ drawer.classList.add('is-open'); });
    document.documentElement.classList.add('cpcd-lock');
    var p = drawer.querySelector('.cpcd__panel'); if (p) p.focus({ preventScroll:true });
  }
  function close(){
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cpcd-lock');
    setTimeout(function(){ if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 350);
    msg('');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function change(line, q){
    if (busy) return;
    busy = true; drawer && drawer.classList.add('is-busy');
    json(root + 'cart/change.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, q) }) })
      .then(render).catch(function(e){ msg(e.message, true); refresh(); })
      .then(function(){ busy = false; drawer && drawer.classList.remove('is-busy'); });
  }

  function add(form, btn){
    var fd = new FormData(form);
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    return json(root + 'cart/add.js', { method:'POST', body: fd })
      .then(function(){ return refresh(); })
      .then(function(){ msg('Zum Warenkorb hinzugefügt'); open(); })
      .catch(function(e){ refresh().then(function(){ msg(e.message || 'Konnte nicht hinzugefügt werden.', true); open(); }); })
      .then(function(){ if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }

  /* ---------- Events ---------- */
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!f || !f.matches || !f.matches('#cp-pd-form')) return;
    if (isCartPage || !window.fetch || !window.FormData) return;
    e.preventDefault();
    add(f, f.querySelector('[data-cp-atc]'));
  });
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t.closest) return;
    var q = t.closest('[data-cpcd-qty]');
    if (q){ e.preventDefault(); change(parseInt(q.getAttribute('data-cpcd-qty'), 10), parseInt(q.getAttribute('data-q'), 10)); return; }
    if (t.closest('[data-cpcd-close]')){
      var a = t.closest('a[data-cpcd-close]'); if (!a) e.preventDefault();
      close(); return;
    }
    var link = t.closest('a.cpsh__cart, a.cpsh__mcart, [data-cp-cart-open]');
    if (link && drawer && !isCartPage && !e.metaKey && !e.ctrlKey){ e.preventDefault(); refresh().then(open, open); }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close(); });
  // Horizon-Kaufbuttons (Standardvorlage) melden Änderungen per Event
  document.addEventListener('cart:update', function(){ refresh().then(function(){ if (!isCartPage) { msg('Zum Warenkorb hinzugefügt'); open(); } }); });
  window.addEventListener('pageshow', function(e){ if (e.persisted) refresh(); });

  window.CPCart = { open: open, close: close, refresh: refresh, add: add };
  refresh().catch(function(){});
})();
